
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 5a7 7 0 11-7 7 7 7 0 017-7m0-2a9 9 0 109 9 9 9 0 00-9-9z"}}),_c('path',{attrs:{"d":"M13.41 12L15 10.41A1 1 0 1013.58 9L12 10.59 10.41 9A1 1 0 009 10.41L10.59 12 9 13.59A1 1 0 0010.41 15L12 13.41 13.58 15A1 1 0 1015 13.59z"}})])
          )
        }
      }
    